import store from '../store';

class TableFilterExtractor {

	constructor() {
		//Set the base url
		this.baseUrl = process.env.MIX_BASE_API;
	}

	extractFilters(rawFilters){
	    //SEtup
	    var formattedFilters = JSON.parse(JSON.stringify(rawFilters));
	    var keys = Object.keys(formattedFilters);

	    //Loop and Build
	    for (var i = 0; i < keys.length; i++)
	    {
	        //setup
	        var filterVal = rawFilters[keys[i]];

	        //Check for Empty or Null
	        if( (Array.isArray(filterVal) && filterVal.length == 0) || filterVal == null || filterVal == '')
	        {
	            continue;
	        }

	        //Special Cases
	        switch(keys[i])
	        {
	            case 'inspection.JobsiteId':
	            case 'incident.JobsiteId':
	            case 'JobsiteId':
	            case 'inspection_observations.jobsite_id':
	            case 'equipment.jobsite_id':
	            case 'corrective_actions.JobsiteId':
	            //case 'employee.current_jobsite_id':
	            case 'jobsites':
	            case 'covid_form_entries.jobsite_id':
	            case 'jobsite_check_ins.jobsite_id':
	            case 'employee_recognitions.jobsite_id':
	            	//Debugging
	            	if(Array.isArray(filterVal))
	            	{
	            		//Extract the ID only
	            		formattedFilters[keys[i]] = [];

	            		//Loop
	            		for (var j = filterVal.length - 1; j >= 0; j--)
	            		{
	            			//Check for Value
	            			if(filterVal[j].hasOwnProperty('JobsiteId'))
	            			{
	            				//Pushn
	            				formattedFilters[keys[i]].push(filterVal[j].JobsiteId);
	            			}
	            		}
	            	}
	            	else
	            	{
	            		//Extract the ID only
	            		formattedFilters[keys[i]] = filterVal.hasOwnProperty('JobsiteId') ? filterVal.JobsiteId : null;
	            	}
	                break;

	            case 'inspection.CreatedByUserId':
	            case 'corrective_actions.assignee_id':
	            case 'jsa_records.UserId':
	            case 'inspection_observations.user_id':
	            	//Debugging
	            	if(Array.isArray(filterVal))
	            	{
	            		//Extract the ID only
	            		formattedFilters[keys[i]] = [];

	            		//Loop
	            		for (var j = filterVal.length - 1; j >= 0; j--)
	            		{
	            			//Check for Value
	            			if(filterVal[j].hasOwnProperty('UserId'))
	            			{
	            				//Pushn
	            				formattedFilters[keys[i]].push(filterVal[j].UserId);
	            			}
	            		}
	            	}
	            	else
	            	{
		                //Extract the ID only
		                formattedFilters[keys[i]] = filterVal.hasOwnProperty('UserId') ? filterVal.UserId : null;
		            }
	                break;

	            case 'incident.equipment_id':
	                //Extract the ID only
	                formattedFilters[keys[i]] = filterVal.hasOwnProperty('equipment_id') ? filterVal.equipment_id : null;
	                break;

	            case 'jobsite.project_manager_id':
	            case 'hse_records.employee_id':
	            case 'equipment.employee_id':
	            case 'inspection.CreatedByEmployeeId':
	            case 'incident.EmployeeId':
	            case 'jobsite_check_ins.employee_id':
	                //Extract the ID only
	                formattedFilters[keys[i]] = filterVal.hasOwnProperty('EmployeeId') ? filterVal.EmployeeId : null;
	                break;

	            case 'interval':
	            case 'graph_by':
	            case 'IsContractor':
	            case 'user.allow_password_login':
                case 'user.is_billable':
	            	formattedFilters[keys[i]] = filterVal[0].id;

	            	//console.log('filterVal:',filterVal[0].id);
	            	break;

	            case 'custom_fields':
	            	//Format is another keyed object, so
	            	// {
	            	// 	custom_field_id: [
	            	// 		option_1,
	            	// 		option_2 //{id: 1, label: 'Option Label', etc....}
	            	// 	]
	            	// }

	            	//console.log(filterVal);

	            	//Setup
	            	var cfKeys = Object.keys(filterVal);

	            	//Loop
	            	for (var j = 0; j < cfKeys.length; j++)
	            	{
	            		//Handle Arrays
	            		if(Array.isArray(formattedFilters['custom_fields'][cfKeys[j]]))
	            		{
	            			//Check for empty
	            			if(formattedFilters['custom_fields'][cfKeys[j]].length === 0)
	            			{
	            				continue;
	            			}

	            			//Set the array
	            			formattedFilters['custom_fields'][cfKeys[j]] = [];

	            			//Loop and PUsh
	            			for (var k = 0; k < filterVal[cfKeys[j]].length; k++)
	            			{
	            				formattedFilters['custom_fields'][cfKeys[j]].push(filterVal[cfKeys[j]][k].id);
	            			}
	            		}
	            		else if(cfKeys[j].includes('_logic') || cfKeys[j].includes('_value')) //Check for NUMBER bindings, where the key is {ID}_logic and {ID}_value
	            		{
	            			//Strip the Key
	            			var keyParts = cfKeys[j].split('_');
	            			var key = keyParts[0];

	            			//Build the input
	            			if(!formattedFilters['custom_fields'][key])
	            			{
	            				formattedFilters['custom_fields'][key] = {
	            					'logic': '',
	            					'value': '',
	            				};
	            			}

	            			//Append
	            			formattedFilters['custom_fields'][key][keyParts[1]] = filterVal[cfKeys[j]];

	            			//Unset the original
	            			delete formattedFilters['custom_fields'][cfKeys[j]];
	            		}
	            		else
	            		{
							//Set the value
							formattedFilters['custom_fields'][cfKeys[j]] = filterVal[cfKeys[j]];
	            		}

	            	}
	            	break;

	            case 'inspection.status_id':
	            case 'incident.status_id':
	            case 'inspection.inspection_form_id':
	            case 'inspectionresult.ComplianceStatusId':
	            case 'non_compliant_insp_form_id':
	            case 'equipment.equipment_type_id':
	            case 'employee.division_id':
	            case 'employee_training_courses.training_course_id':
	            case 'incident.InjuryTypeId':
	            case 'incident.IncidentTypeId':
	            case 'jobsite.DivisionId':
	            case 'jobsite.JobsiteId':
	            case 'subcontractors.status_id':
	            case 'osha_db_establishments.site_state':
	            case 'osha_db_establishments.sic_code':
	            case 'osha_db_establishments.naics_code':
	            case 'hse_types.hse_type_id':
                case 'division.DivisionId':
                case 'NonCompliant_SectionId':
                case 'NonCompliant_ElementId':
                case 'incident_types':
                case 'inspection_forms':
                case 'divisions':
                case 'corrective_actions.status_id':
                case 'behavior_id':
                case 'hazard_id':
                case 'condition_id':
                case 'training_course_catalogs.training_catalog_id':
                case 'elements':
                case 'sections':
                case 'jsa_records.status_id':
                case 'covid_form_entries.visitor_or_employee':
                case 'covid_form_entries.covid_form_id':
                case 'covid_form_entries.entry_status':
                case 'role_user.role_id':
                case 'permission_role.permission_id':
                case 'jobsite_check_ins.guest_or_employee':
                case 'jobsite_check_ins.check_in_type':
                case 'employee_recognitions.recognition_id':
                case 'jsa_records.jsa_template_id':
                case 'employee.current_jobsite_id':
                case 'employee.IsActive':
                case 'employee.subcontractor_id':
	                //Extract the ID only
	                formattedFilters[keys[i]] = [];

	                //Loop and SEt
	                for (var j = 0; j < filterVal.length; j++)
	                {
	                    formattedFilters[keys[i]].push(filterVal[j].id);
	                }
	                break;

	            default:
	                //Do nothing
	                break;
	        }
	    }

	    //Send it
	    return formattedFilters;
	}
}

export default new TableFilterExtractor;